import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "settings-home-card__header" }
const _hoisted_2 = { class: "settings-home-card__title-row" }
const _hoisted_3 = { class: "settings-home-card__title" }
const _hoisted_4 = { class: "settings-home-card__description" }
const _hoisted_5 = { class: "settings-home-card__features" }
const _hoisted_6 = { class: "settings-home-card__feature-text" }

import Mdi from '@/corePagesModule/components/Mdi.vue';

/**
 * 設定ホームで表示するカードのプロパティ
 */
type Props = {
  /** 遷移先のパス */
  to: string;
  /** カードのタイトル */
  title: string;
  /** カード説明 */
  description: string;
  /** 表示する機能一覧 */
  features: string[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsHomeCard',
  props: {
    to: {},
    title: {},
    description: {},
    features: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: _ctx.to,
    class: "settings-home-card"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createVNode(Mdi, {
            class: "settings-home-card__icon",
            icon: "keyboard_arrow_right",
            "aria-hidden": "true"
          })
        ]),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.description), 1)
      ]),
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature) => {
          return (_openBlock(), _createElementBlock("li", {
            key: feature,
            class: "settings-home-card__feature"
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("span", {
              class: "settings-home-card__bullet",
              "aria-hidden": "true"
            }, "・", -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(feature), 1)
          ]))
        }), 128))
      ])
    ], undefined, true),
    _: 1
  }, 8, ["to"]))
}
}

})